export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Тренинг по управлению конфликтами — обучение руководителей и сотрудников",
        "description": "Тренинг по управлению конфликтами в коллективе: причины конфликтов, профилактика, разрешение споров, сложные разговоры и инструменты руководителя. Корпоративное обучение.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Тренинг по управлению конфликтами",
        "description": "Корпоративное обучение руководителей и управленческих команд навыкам управления конфликтами: диагностика причин конфликтов, профилактика, сложные разговоры, разрешение споров между сотрудниками и подразделениями, медиация и фиксация договорённостей.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение управлению конфликтами, управление конфликтами в коллективе, разрешение конфликтов, конфликтология для руководителей",
        "url": "https://business-training.by/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое управление конфликтами в коллективе?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Управление конфликтами — это практический управленческий навык: вовремя замечать напряжение, понимать причины конфликта, организовывать разговор между сторонами и переводить ситуацию в конкретное решение и рабочие договорённости. Задача руководителя — не избегать разногласий, а не давать им разрушать результат команды."
            }
          },
          {
            "@type": "Question",
            "name": "Почему возникают конфликты между сотрудниками?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Чаще всего конфликты возникают из-за неясных зон ответственности, разных целей и KPI подразделений, неясных ожиданий, недостатка коммуникации, несправедливого распределения нагрузки или ресурсов, а также из-за изменений и ошибок руководителя. Поэтому важно искать не «виноватого», а реальную причину конфликта."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю правильно разрешать конфликт?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сначала руководитель диагностирует ситуацию: кто участники, в чём их интересы и что является реальной проблемой. Затем отделяет факты от оценок, выслушивает обе стороны, помогает сформулировать суть разногласия и переводит разговор в поиск решения. В завершение важно зафиксировать договорённости: конкретные действия, сроки и ответственность, а затем проверить их выполнение."
            }
          },
          {
            "@type": "Question",
            "name": "Нужно ли руководителю вмешиваться в конфликт сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Не всегда. Если разногласие рабочее и стороны способны договориться самостоятельно, руководителю достаточно задать правила обсуждения. Вмешиваться нужно, когда конфликт повторяется, влияет на результат, переходит в открытое противостояние или затрагивает системные проблемы компании. Важно определить масштаб ситуации, а не решать всё за сотрудников."
            }
          },
          {
            "@type": "Question",
            "name": "Какие бывают виды конфликтов в коллективе?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Можно выделить рабочее разногласие, конструктивную дискуссию, межличностный конфликт, конфликт интересов, конфликт из-за распределения ответственности, конфликт между сотрудником и руководителем и конфликт между подразделениями. Каждый тип требует своего подхода: что-то решается переговором сторон, что-то — вмешательством руководителя или пересмотром правил."
            }
          },
          {
            "@type": "Question",
            "name": "Как научиться проводить сложные разговоры?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сложный разговор — это навык, который отрабатывается: начинать разговор без обвинений, говорить о конкретном поведении и его последствиях, задавать вопросы и слушать ответы, сохранять конструктивный тон при эмоциональной реакции собеседника. На тренинге участники практикуются на реальных ситуациях и получают обратную связь по своей коммуникации."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли научить сотрудников конструктивно разрешать конфликты?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Сотрудников учат отделять факты от оценок, формулировать суть проблемы, слушать собеседника, искать общее решение и фиксировать договорённости. Но устойчивый результат появляется тогда, когда эти навыки поддерживаются управленческой системой: понятными правилами, зонами ответственности и регулярной обратной связью."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится тренинг по управлению конфликтами?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Корпоративный тренинг обычно занимает 1–2 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а управленческая программа — несколько месяцев. Точный формат и продолжительность определяются после диагностики потребностей и обсуждения задач компании."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под реальные конфликты нашей компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап подготовки. Мы не используем шаблонные решения. Сначала разбираемся в реальных конфликтных ситуациях компании: между какими сотрудниками и подразделениями возникают споры, каковы их причины. После этого программа настраивается под специфику бизнеса, а реальные кейсы компании встраиваются в отработку."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли тренинг новым руководителям?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, для новых руководителей тренинг особенно полезен. Они часто впервые сталкиваются с необходимостью разбирать конфликты между бывшими коллегами, проводить сложные разговоры и выдерживать управленческую позицию. Программа даёт базовые инструменты диагностики конфликта и практическую отработку, которая помогает быстрее освоить новую роль."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли включить управление конфликтами в программу обучения руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, управление конфликтами может быть отдельным модулем комплексной программы развития руководителей. Оно естественно сочетается с темами обратной связи, делегирования, мотивации и управления изменениями. Формат подбирается под цели компании и уровень участников."
            }
          },
          {
            "@type": "Question",
            "name": "Что происходит после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "После обучения участники применяют инструменты в реальной работе. При необходимости мы проводим сопровождение: разбираем конкретные конфликтные ситуации, которые возникли после тренинга, помогаем скорректировать действия и закрепить навыки. При системной работе определяется, изменилось ли управленческое поведение и качество взаимодействия в команде."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}